import { memo } from 'react';
import { CallCardAuditLogGrid } from '@/components/callcard/CallCardAuditLogGrid';

interface CallCardAuditLogTabProps {
  callCardId: number;
  callCardCreatedBeforeAuditLogging: boolean;
}

export const CallCardAuditLogTab = memo(function CallCardAuditLogTab({
  callCardId,
  callCardCreatedBeforeAuditLogging,
}: CallCardAuditLogTabProps) {
  return (
    <div className="tab-content-panel">
      <CallCardAuditLogGrid
        callCardId={callCardId}
        callCardCreatedBeforeAuditLogging={callCardCreatedBeforeAuditLogging}
        active={true}
      />
    </div>
  );
});
